import React from 'react';

export const BreadcrumbPreview = ({ component, onClick, isSelected }) => {
  const { commonAttrs, specificAttrs } = component;
  const { items, separator, showHome } = specificAttrs || {};
  const itemsArray = (items || 'Home,Products,Category').split(',');
  
  const containerStyle = {
    padding: `${commonAttrs?.paddingTop || 16}px ${commonAttrs?.paddingRight || 16}px ${commonAttrs?.paddingBottom || 16}px ${commonAttrs?.paddingLeft || 16}px`,
    margin: `${commonAttrs?.marginTop || 8}px ${commonAttrs?.marginRight || 0}px ${commonAttrs?.marginBottom || 8}px ${commonAttrs?.marginLeft || 0}px`,
    width: commonAttrs?.width === 'auto' ? 'auto' : `${commonAttrs?.width || 100}%`,
    cursor: onClick ? 'pointer' : 'default',
    border: isSelected ? '2px solid #3B82F6' : '2px solid transparent',
    borderRadius: '4px'
  };
  
  return (
    <div style={containerStyle} onClick={onClick}>
      <nav style={{ fontSize: '14px' }}>
      {itemsArray.map((item, idx) => (
        <span key={idx}>
          <a
            href="#"
            style={{
              color: idx === itemsArray.length - 1 ? '#6B7280' : '#3B82F6',
              textDecoration: 'none',
              fontWeight: idx === itemsArray.length - 1 ? '500' : '400'
            }}
          >
            {item.trim()}
          </a>
          {idx < itemsArray.length - 1 && (
            <span style={{ margin: '0 8px', color: '#9CA3AF' }}>{separator || '/'}</span>
          )}
        </span>
      ))}
      </nav>
    </div>
  );
};
